import {
  Role,
  UpdateRoleForm,
  CreateRoleForm,
  AppPermission
} from "@closerplatform/spinner-openapi";
import { FieldState, FormState } from "formstate";
import { RoleForm, RoleFields } from "./types";

export const mapRoleToForm = (role: Role) => {
  return new FormState<RoleFields>({
    id: new FieldState(role.id),
    name: new FieldState(role.name),
    orgId: new FieldState(role.orgId),
    permissions: new FieldState(role.permissions || [])
  });
};

export const createNewRoleForm = (): RoleForm => {
  return new FormState({
    id: new FieldState(""),
    name: new FieldState(""),
    orgId: new FieldState(""),
    permissions: new FieldState<AppPermission[]>([])
  });
};

export const copyExistingForm = (form: RoleForm): RoleForm => {
  return new FormState<RoleFields>({
    id: new FieldState(form.$.id.$),
    name: new FieldState(form.$.name.$),
    orgId: new FieldState(form.$.orgId.$),
    permissions: new FieldState(form.$.permissions.$)
  });
};

export const mapFormToCreateForm = (form: RoleForm): CreateRoleForm => {
  return {
    name: form.$.name.$
  };
};

export const mapFormToUpdateForm = (form: RoleForm): UpdateRoleForm => {
  return {
    name: form.$.name.$,
    permissions: form.$.permissions.$
  };
};

export const checkPermissionsEnabled = (available: AppPermission[], toCheck: AppPermission[]) => {
  return toCheck.every((permission) => available.includes(permission));
};
